import { InternalRootViewModel } from './internal-root-view-model';
import { ClassConstructor } from '@nts/std/serialization';
import { AggregateMetaDataInterface, CollectionViewModelInterface, CoreOrchestratorViewModelInterface, IdentityInterface, ItemViewModelInterface, ModelInterface, RootViewModelInterface } from '@nts/std/interfaces';

export class MasterDetailRootViewModel<
    TModel extends ModelInterface<TIdentity>, 
    TIdentity extends IdentityInterface
> extends InternalRootViewModel<TModel, TIdentity> implements ItemViewModelInterface<TIdentity, TModel>, RootViewModelInterface<TIdentity, TModel> {

    async initItemViewModel(
        domainModel: TModel,
        aggregateMetaData: AggregateMetaDataInterface,
        orchestratorViewModel: CoreOrchestratorViewModelInterface,
        ownerCollection?: CollectionViewModelInterface<any>,
        isNewItem?: boolean,
        path?: string,
        isMock: boolean = false,
        domainModelType: ClassConstructor<TModel> = null
    ) {
        this.isMock = isMock;

        await this.initAggregateElementViewModel({
            domainModel,
            aggregateMetaData,
            orchestratorViewModel,
            isMock,
            domainModelType
        });
    }
}
